module.exports = __webpack_public_path__ + "media/unipod/icon-cabin-assembly-white-27105959.svg";